import type { MetadataFieldWithValue } from '@/model/Metadata.model';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form-latest';
import '../MetadataFields.scss';

interface TextProps {
  field: MetadataFieldWithValue;
  testId?: string;
}

export const Text: FC<TextProps> = ({ field, testId = 'metadata-text-field' }) => {
  const { register } = useFormContext();

  return (
    <div className="metadata-text-container">
      <input
        type="text"
        style={{ marginBottom: 0 }}
        defaultValue={field.value ?? undefined}
        {...register(`metadata[${field.glossary_api_id}].value`, {
          required: field.required === true && 'This field is required',
          maxLength: 250,
        })}
        data-testid={testId}
      />
    </div>
  );
};
